import React from "react";

import { DpExpiryStatus, EXPIRY_STATUS_BADGE, EXPIRY_STATUS_LABELS } from "../api/documentsApi";

/** Situação de vencimento calculada no backend, com os dias no título. */
export default function DocumentExpiryBadge({
  status,
  daysToExpire,
}: {
  status: DpExpiryStatus;
  daysToExpire: number | null;
}) {
  const detail =
    daysToExpire === null
      ? undefined
      : daysToExpire < 0
        ? `Venceu há ${Math.abs(daysToExpire)} dia(s)`
        : daysToExpire === 0
          ? "Vence hoje"
          : `Vence em ${daysToExpire} dia(s)`;

  return (
    <span className={`dpBadge ${EXPIRY_STATUS_BADGE[status]}`} title={detail}>
      {EXPIRY_STATUS_LABELS[status]}
      {status === "A_VENCER" && daysToExpire !== null ? ` · ${daysToExpire}d` : null}
    </span>
  );
}
